import { createSlice } from '@reduxjs/toolkit';

const loanSlice = createSlice({
  name: 'loanSlice',
  initialState: {
    loan: [],
    totalRowCount: 0,
    isloanLoading: false,
  },
  reducers: {
    setLoan: (state, action) => {
      state.loan = action.payload.data.loan;
      state.totalRowCount = action.payload.data.totalRowCount;
    },
    setLoanLoading: (state, action) => {
      state.isloanLoading = action.payload;
    },
  },
});

export const { setLoan, setLoanLoading } = loanSlice.actions;
export default loanSlice.reducer;
